<template>
  <div>
    <NavBar />
    <v-container>
      <MainMenu />
      <notification-container />
      <document-type-table />
    </v-container>
  </div>
</template>

<script>
import DocumentTypeTable from '@/modules/catalogs/components/DocumentTypeTable'

export default {
  name: 'DocumentTypePage',
  components: {
    DocumentTypeTable
  }
}
</script>
